<template>
  <div class="slider-verify-container">
    <div v-if="visible" class="slider-verify-modal">
      <div class="slider-verify-header">
        <span>请完成安全验证</span>
        <i class="close-icon" @click="handleClose">×</i>
      </div>
      <div class="slider-verify-content">
        <div class="slider-bg-container" ref="bgContainer">
          <!-- 背景图片 -->
          <img :src="bgImage" class="bg-image" ref="bgImage" @load="onBgImageLoad"/>

          <!-- 拼图缺口 - 使用明显的样式 -->
          <div
            class="puzzle-slot"
            :style="{
              left: `${targetPosition}px`,
              top: `${puzzleY}px`,
              display: success ? 'none' : 'block',
              width: `${puzzleWidth}px`,
              height: `${puzzleHeight}px`
            }"
            v-if="showPuzzleSlot"
          ></div>

          <!-- 滑块 - 使用背景图片直接显示截取的部分 -->
          <div
            class="slider-block"
            :style="{
              left: `${sliderPosition}px`,
              top: `${puzzleY}px`,
              display: success ? 'none' : 'block',
              width: `${puzzleWidth}px`,
              height: `${puzzleHeight}px`,
              backgroundImage: bgImageLoaded ? `url(${bgImage})` : 'none',
              backgroundPosition: `-${targetPosition}px -${puzzleY}px`
            }"
            ref="sliderBlock"
          ></div>

          <!-- 成功提示 -->
          <div v-if="success" class="verify-success-tip">
            <i class="success-icon">✓</i>
            验证通过
          </div>
        </div>
        <div class="slider-container" ref="sliderContainer">
          <div
            class="slider-track"
            :style="{width: `${sliderPosition}px`}"
          ></div>
          <div
            class="slider-thumb"
            :style="{left: `${sliderPosition}px`}"
            ref="sliderThumb"
            @mousedown="handleMouseDown"
            @touchstart="handleTouchStart"
          >
            <i class="thumb-icon">→</i>
          </div>
          <div class="slider-text" v-if="!isDragging && !success">
            向右滑动完成验证
          </div>
          <div class="slider-text success-text" v-if="success">
            验证通过
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SliderVerify',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 图片集合，可以替换为自己的图片
      bgImages: [
        // 'https://picsum.photos/id/1018/300/200',
        // 'https://picsum.photos/id/1015/300/200',
        // 'https://picsum.photos/id/1019/300/200',
        // 'https://picsum.photos/id/1020/300/200',
        // 'https://picsum.photos/id/1021/300/200'
        '/images/montain.jpg',
        '/images/fog.jpg',
        '/images/rainy.jpg',
        '/images/sea.jpg',
        '/images/bear.jpg'
      ],
      bgImage: '',
      sliderPosition: 0,
      isDragging: false,
      startX: 0,
      originX: 0,
      targetPosition: 0,
      success: false,
      sliderWidth: 0,
      maxOffset: 0,
      errorCount: 0,
      puzzleImage: '',
      showPuzzleSlot: false,
      puzzleWidth: 40,
      puzzleHeight: 40,
      puzzleY: 0,
      bgImageLoaded: false
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.resetSlider()
        this.$nextTick(() => {
          this.initSlider()
        })
      }
    }
  },
  methods: {
    initSlider() {
      // 随机选择一张背景图片
      this.bgImage = this.bgImages[Math.floor(Math.random() * this.bgImages.length)]

      // 计算滑块范围
      this.sliderWidth = this.$refs.sliderContainer.clientWidth
      this.maxOffset = this.sliderWidth - this.$refs.sliderThumb.clientWidth

      // 设置目标位置，在滑块宽度的20%到80%之间
      this.targetPosition = Math.floor(this.maxOffset * 0.2 + Math.random() * (this.maxOffset * 0.6))
    },

    onBgImageLoad() {
      // 图片加载完成后，设置拼图位置并显示
      this.bgImageLoaded = true
      const bgImg = this.$refs.bgImage

      if (!bgImg || !bgImg.complete) return

      // 计算拼图位置（垂直方向随机）
      const maxPuzzleY = bgImg.height - this.puzzleHeight
      this.puzzleY = Math.floor(maxPuzzleY * 0.2 + Math.random() * (maxPuzzleY * 0.6))

      // 显示拼图缺口
      this.showPuzzleSlot = true
    },

    resetSlider() {
      this.sliderPosition = 0
      this.isDragging = false
      this.success = false
      this.errorCount = 0
      this.startX = 0
      this.originX = 0
      this.puzzleImage = ''
      this.showPuzzleSlot = false
      this.bgImageLoaded = false
    },

    handleClose() {
      this.$emit('close')
    },

    handleMouseDown(event) {
      if (this.success) return

      this.isDragging = true
      this.startX = event.clientX
      this.originX = this.sliderPosition

      document.addEventListener('mousemove', this.handleMouseMove)
      document.addEventListener('mouseup', this.handleMouseUp)
    },

    handleMouseMove(event) {
      if (!this.isDragging) return

      const moveX = event.clientX - this.startX
      let newPosition = this.originX + moveX

      // 限制滑块位置在有效范围内
      if (newPosition < 0) newPosition = 0
      if (newPosition > this.maxOffset) newPosition = this.maxOffset

      this.sliderPosition = newPosition
    },

    handleMouseUp() {
      if (!this.isDragging) return

      this.isDragging = false
      document.removeEventListener('mousemove', this.handleMouseMove)
      document.removeEventListener('mouseup', this.handleMouseUp)

      this.verifyPosition()
    },

    // 触摸设备支持
    handleTouchStart(event) {
      if (this.success) return

      this.isDragging = true
      this.startX = event.touches[0].clientX
      this.originX = this.sliderPosition

      document.addEventListener('touchmove', this.handleTouchMove)
      document.addEventListener('touchend', this.handleTouchEnd)
    },

    handleTouchMove(event) {
      if (!this.isDragging) return

      const moveX = event.touches[0].clientX - this.startX
      let newPosition = this.originX + moveX

      if (newPosition < 0) newPosition = 0
      if (newPosition > this.maxOffset) newPosition = this.maxOffset

      this.sliderPosition = newPosition
    },

    handleTouchEnd() {
      if (!this.isDragging) return

      this.isDragging = false
      document.removeEventListener('touchmove', this.handleTouchMove)
      document.removeEventListener('touchend', this.handleTouchEnd)

      this.verifyPosition()
    },

    verifyPosition() {
      // 验证滑块位置是否正确（允许10px的误差）
      if (Math.abs(this.sliderPosition - this.targetPosition) < 10) {
        this.success = true

        // 通知父组件验证成功
        setTimeout(() => {
          this.$emit('success')
        }, 500)
      } else {
        // 验证失败，重置滑块
        this.errorCount++
        if (this.errorCount >= 3) {
          // 多次失败，重新加载图片和目标位置
          setTimeout(() => {
            this.resetSlider()
            this.initSlider()
          }, 500)
        } else {
          this.sliderPosition = 0
        }
      }
    }
  }
}
</script>

<style scoped>
.slider-verify-container {
  font-family: Arial, sans-serif;
}

.slider-verify-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 320px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 9999;
}

.slider-verify-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.close-icon {
  cursor: pointer;
  font-size: 20px;
  color: #999;
}

.slider-verify-content {
  padding: 16px;
}

.slider-bg-container {
  position: relative;
  width: 100%;
  height: 200px;
  margin-bottom: 16px;
  overflow: hidden;
  border-radius: 4px;
}

.bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.slider-block {
  position: absolute;
  border-radius: 4px;
  border: 2px solid #fff;
  box-sizing: border-box;
  pointer-events: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  /* 下面的属性将通过内联样式动态设置 */
  /* width, height, left, top, backgroundImage, backgroundPosition */
}

.puzzle-slot {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 4px;
  border: 0px dashed #1890ff;
  box-sizing: border-box;
  pointer-events: none;
  /* 下面的属性将通过内联样式动态设置 */
  /* width, height, left, top */
}

.verify-success-tip {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 8px 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-icon {
  color: #52c41a;
  margin-right: 8px;
}

.slider-container {
  position: relative;
  width: 100%;
  height: 40px;
  background-color: #f5f5f5;
  border-radius: 20px;
  overflow: hidden;
}

.slider-track {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #1890ff;
  border-radius: 20px 0 0 20px;
}

.slider-thumb {
  position: absolute;
  top: 0;
  width: 40px;
  height: 40px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  z-index: 2;
}

.thumb-icon {
  color: #1890ff;
  font-weight: bold;
}

.slider-text {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  user-select: none;
}

.success-text {
  color: #fff;
  font-weight: bold;
}
</style>
